import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import './index.scss';
import { Layout } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { Content, Header } from 'antd/es/layout/layout';
import HeadderCmp from '@/components/Layouts/Header';
import HydrodigitalSimpleLogo from '@/assets/img/hydrodigital-simple-logo.svg?url';

interface Props {
	children: React.ReactNode;
}

const GeneralLayout: React.FC<Props> = ({ children }) => {
	const navigate = useNavigate();
	const [collapsed, setCollapsed] = useState(false);

	return (
		<Layout style={{ minHeight: '100vh' }}>
			<Sider
				className="sidebar-configuration"
				collapsible={false}
				collapsed={collapsed}
				onCollapse={(value) => setCollapsed(value)}
				style={{
					background: '#f7f9fc',
					padding: '15px',
					height: '100vh',
					overflow: 'auto',
					flex: ' 0 0 228px !important',
					maxWidth: 228,

					minWidth: 200,
					width: 228,
				}}
			>
				<div className="flex column" style={{ height: 'inherit' }}>
					<div className="flex flex-col items-center justify-center" style={{ textAlign: 'center', marginTop: '1rem', marginBottom: '1rem' }}>
						<img
							className="w-6"
							src={HydrodigitalSimpleLogo}
							alt="logo"
							style={{ cursor: 'pointer' }}
							onClick={() => {
								navigate('/');
							}}
						/>
					</div>
					{children}
				</div>
			</Sider>
			<Layout className="site-layout" style={{ background: 'white', overflowY: 'auto' }}>
				<Header style={{ padding: 0, background: 'white' }}>
					<HeadderCmp />
				</Header>
				<Content style={{ margin: '0 16px', background: 'white' }}>
					<Outlet />
				</Content>
				{/* <Footer style={{ textAlign: "center" }}>
          Ant Design ©2023 Created by Ant UED
        </Footer> */}
			</Layout>
		</Layout>
	);
};

export default GeneralLayout;
